import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { auth } from "./config/firebaseConfig"; // Ajuste o caminho conforme necessário
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";
import Dashboard from "./pages/Dashboard"; // Importar o Dashboard
import RedirectPage from "./pages/Redirect"; // Importar a página de redirecionament
import "./App.css";

function App() {
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isRegistering, setIsRegistering] = useState(false);

  return (
    <Router>
      <AppRoutes
        user={user}
        setUser={setUser}
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        isRegistering={isRegistering}
        setIsRegistering={setIsRegistering}
      />
    </Router>
  );
}

function AppRoutes({ user, setUser, email, setEmail, password, setPassword, isRegistering, setIsRegistering }) {
  const navigate = useNavigate(); // Hook para navegação

  const handleLogin = async () => {
    try {
      const result = await signInWithEmailAndPassword(auth, email, password);
      setUser(result.user);
      navigate("/dashboard"); // Redireciona para o dashboard após login
    } catch (error) {
      console.error("Error during login:", error.message);
    }
  };

  const handleRegister = async () => {
    try {
      const result = await createUserWithEmailAndPassword(auth, email, password);
      setUser(result.user);
      navigate("/dashboard"); // Redireciona para o dashboard após registro
    } catch (error) {
      console.error("Error during registration:", error.message);
    }
  };

  return (
    <Routes>
      {/* Página pública */}
      <Route
        path="/"
        element={
          <div className="App">
            <header className="App-header">
              <p>Bem-vindo ao URL Shortener!</p>
              {!user ? (
                <div>
                  <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <input
                    type="password"
                    placeholder="Senha"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  {isRegistering ? (
                    <button onClick={handleRegister}>Registrar</button>
                  ) : (
                    <button onClick={handleLogin}>Login</button>
                  )}
                  {/* <p>
                    {isRegistering ? "Já tem uma conta?" : "Não tem uma conta?"}{" "}
                    <span
                      style={{ color: "blue", cursor: "pointer" }}
                      onClick={() => setIsRegistering(!isRegistering)}
                    >
                      {isRegistering ? "Faça login" : "Registre-se"}
                    </span>
                  </p> */}
                </div>
              ) : (
                <p>Olá, {user.email}!</p>
              )}
            </header>
          </div>
        }
      />

      {/* Página de redirecionamento pública */}
      <Route path="/:shortCode" element={<RedirectPage />} />

      {/* Página protegida */}
      <Route
        path="/dashboard"
        element={
          user ? (
            <Dashboard />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
    </Routes>
  );
}

export default App;